import React from "react";
import { useHistory } from "react-router-dom";

import { Button } from "components/forms";
import { Routes } from "../../constants/routes";
import "./NotFound.styles.scss";

export const NotFound: React.FC = () => {
  const { replace } = useHistory();

  return (
    <div className="page flex-col-fc-fc">
      <div className="not-found__error flex-col-fc-fc">404</div>
      <span className="not-found__title">PAGE NOT FOUND</span>
      <span className="not-found__subtitle">Why don’t you try of these pages instead?</span>
      <div className="not-found__redirection flex-row-fc-fc">
        <Button
          className="not-found__redirection-home"
          variant="square"
          title="Home"
          onClick={() => replace(Routes.myDeals)}
        />
        <a
          href="https://form.asana.com/?k=e_olgIBpwIAsjPgN7Cd9aQ&d=1179264452013401"
          className="link link__contact-us no-outline scale-click"
        >
          CONTACT US
        </a>
      </div>
    </div>
  );
};
